import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { Field } from './Field';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Wraps the control in a Field with this mono label. */
  label?: string;
  error?: string;
}

/** 44px text field on the surface colour. Pass `bg-bg` when it sits on a surface
 * panel (modals, the sign-in column). */
export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, label, error, ...props }, ref) => {
  const input = (
    <input
      ref={ref}
      aria-invalid={error ? true : undefined}
      className={cn(
        'h-11 w-full rounded-md border border-line bg-surface px-[13px] text-[15px] text-ink',
        'placeholder:text-faint focus:border-line2 focus:outline-none',
        'disabled:cursor-not-allowed disabled:text-mute',
        error && 'border-down',
        className
      )}
      {...props}
    />
  );
  if (!label) return input;
  return (
    <Field label={label} hint={error} hintTone="down">
      {input}
    </Field>
  );
});

Input.displayName = 'Input';
